// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"344":"79a36290","950":"79a36290"}[chunkId] + ".css";
};